var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M33.219 18.634H22.784V37.36H33.22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M23.447 27.997c0-3.64 1.689-7.113 4.538-9.363-5.168-4.07-12.654-3.176-16.729 2.018-4.074 5.162-3.18 12.639 2.02 16.709a11.905 11.905 0 0 0 14.742 0 11.91 11.91 0 0 1-4.571-9.364"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "M47.297 27.997c0 6.584-5.333 11.911-11.925 11.911-2.683 0-5.267-.893-7.354-2.547 5.168-4.07 6.062-11.547 1.988-16.742-.597-.728-1.26-1.423-1.988-1.985 5.168-4.07 12.687-3.176 16.728 2.018a11.78 11.78 0 0 1 2.551 7.345m-1.127 7.378v-.397h.166v-.066h-.397v.066h.166v.397zm.763 0v-.463H46.8l-.132.331-.133-.33h-.132v.462h.1v-.364l.132.298h.099l.133-.298v.364z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/Master.9622fe4cb6b8afed8b03a3df28b38bcc.svg";
export { ForwardRef as ReactComponent };